import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'

import { GetConsultationListResponseItem2 } from 'src/api/requests'
import { dayMonthYearHourMinutesFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

import { ConsultationStatusTag } from './ConsultationStatusTag'

export const useColumns = () => {
  const { t } = useLocales()

  const columns: ColumnType<GetConsultationListResponseItem2>[] = [
    {
      key: 'datetime',
      title: t('appointments.date_and_time'),
      render: (_, { consultationDate }) =>
        dayjs(consultationDate).format(dayMonthYearHourMinutesFormatWithDot)
    },
    {
      key: 'consultation type',
      title: t('consultations.consultation_type'),
      render: (_, { consultationType }) =>
        consultationType ? t(`consultation_form.type.${consultationType}`) : '-'
    },
    {
      key: 'institution',
      title: t('common.institution'),
      dataIndex: ['legalEntity', 'name']
    },
    {
      key: 'status',
      title: t('analysis.status'),
      render: (_, { status }) => <ConsultationStatusTag status={status} />
    }
  ]

  return { columns }
}
